import { getCookie } from 'App/lib/util';

export default class PardotCookieManager {

    _cookieName = 'rhythm-pardot-visitor-id';

    // set an interval to figure out when the pardot pi javascript object is initialized
    constructor() {
        this.interval = setInterval(() => {
            if (pi != null) {
                this.visitorId = this.getVisitorId();
                this.checkIfCookieExists();
                clearInterval(this.interval);
            }
        }, 500);
    }

    checkIfCookieExists() {
        const customCookie = getCookie(this._cookieName);
        if (customCookie === '' && this.visitorId !== '') {
            this.createCookie();
        }
    }

    getVisitorId() {
        let visitorId = '';
        if (pi.tracker != null) {
            visitorId = pi.tracker.visitor_id;
        }
        return visitorId;
    }

    createCookie() {
        const date = new Date;
        date.setFullYear(date.getFullYear() + 10);
        document.cookie = `${this._cookieName}=${this.visitorId}; expires='+${date}; path=/`;
    }
}
